import {API_URL, apiDelete} from '../api'

export const deleteThumbnail = async (id: string) => {
    return await apiDelete(API_URL, `admin/user_thumbnail/${id}`)
}
